import React from "react";
import { isEmpty } from "lodash";

import { connect } from "react-redux";

import { be } from "../../../../utils/bliss";
import UserDuck from "../../../../redux/ducks/user";

import Button from "../../../../components/button/button";
import FollowToggler from "../../../../components/follow/followToggler";

import GetInfoTable from "./getInfoTable";
import "./showInfoTable.sass";

const MODULE_NAME = "ProjectDetailScreen";

const ShowInfoTable = ({ project, user, showOnMobile, scrollToMyRef, showSelectFinancing }) => {
  const responsiveClass = showOnMobile
    ? "d-block d-sm-none "
    : `d-none d-sm-block${showSelectFinancing ? " flip-select-financing-fix" : ""}`;
  return (
    <div className={`col-md ${responsiveClass}`}>
      {project.isPublicProject && !isEmpty(user) && project.type !== "financing" && (
        <FollowToggler detail project={project} />
      )}
      <GetInfoTable project={project} scrollToMyRef={scrollToMyRef} showSelectFinancing={showSelectFinancing} />
      {/* {isPublicProject && ( */}
      {/* <Fragment> */}
      <div className={be(MODULE_NAME, "spacing", "sm")} />
      <div className="row">
        {/* <div className='col-sm-6'> */}
        {/* <Button share>Komunita</Button> */}
        {/* </div> */}

        {project.type !== "financing" && (
          <div className="col-sm-6 text-center m-auto">
            <div className={be(MODULE_NAME, "buttonContainer")}>
              <Button
                black
                target="_blank"
                to={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`}
              >
                <svg
                  data-name="Vrstva 1"
                  height="19"
                  viewBox="0 0 11.07 13.57"
                  width="14"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.69.14h.1s0-.06.13.05a9.24 9.24 0 0 1 1.17-.15c.42 0 .83.09.86.5.14 2.73 0 5.49.12 8.18a.66.66 0 0 1-.18.58.54.54 0 0 1-.69-.06 5.67 5.67 0 0 1-1.13.06 11 11 0 0 1-1.13-.16h-.09a.46.46 0 0 1-.31-.11.41.41 0 0 1-.32-.24.47.47 0 0 1 .16-.51s-.06-.27-.1-.54c-.71.93-1.31 2-1.93 2.94 0 0 .08 0-.1.16l-.61.88a11.27 11.27 0 0 1-1.33 1.69.42.42 0 0 1-.43.1.59.59 0 0 1-.53 0 6 6 0 0 1-2.04-2.12H.22c-.4-.25-.17-.94 0-1.28a10.84 10.84 0 0 1 2.09-2.42.18.18 0 0 1 .06-.29h.11c.09 0 .07.05.07.05.54-.5 1.07-1 1.59-1.55l-.2-.08h-.09c-.18 0-.34-.15-.53-.2a.35.35 0 0 1-.16-.11c-.09-.11-.06-.32-.08-.38A5.55 5.55 0 0 1 3 2.29a1.39 1.39 0 0 1 .38-.42 6.24 6.24 0 0 1 .91-.42s-.17-.73.35-.16l1-.31a.17.17 0 0 1 .21-.07h.25C6.93.68 7.76.48 8.6.31zM3.87 4.48a.85.85 0 0 1 .77-.19c.16 0 .33-.06.5-.06a.84.84 0 0 1 .65.27A.92.92 0 0 1 5 5.95l-.36.51-.25.3a4.62 4.62 0 0 0 1.51.82l.14.06v-.08a2.89 2.89 0 0 1 0-.29c0-.22.22-.39.61-.16a.76.76 0 0 1 .17-.36.25.25 0 0 1 .4.09l.36-.2c.22-.16.51 0 .56.38a3.76 3.76 0 0 0 .5 1.37c0 .07.09.05.13.06a9.11 9.11 0 0 0 1.28.14v-.94h-.09a8.54 8.54 0 0 1-1.34-.08s-.17 0-.18-.2.51-.2.95-.18h.64V5.71s0-.06-.11-.09a1.38 1.38 0 0 1-.56-.19c-.1-.06-.17-.49.22-.34l.45.12V3.77h-.1a1 1 0 0 1-.57 0 .18.18 0 0 1-.1-.26c.09-.22.43-.15.73-.18h.05v-.62h-.07a3.82 3.82 0 0 1-.68-.07s-.31-.23-.06-.39.41.04.75.04V1.07a4.26 4.26 0 0 0-.62 0s.41.57 0 .54c-.17 0-.27-.22-.4-.44l-1.4.26.07.1a4.37 4.37 0 0 1 .54.83c.13.28-.16.48-.37.21a11.52 11.52 0 0 1-.7-1l-.58.14c.18.24.48.9.07.82-.11 0-.18-.14-.23-.23s-.3-.48-.3-.48L5.34 2s-.1-.11.07.14a6.24 6.24 0 0 1 .49.83s0 .23-.11.29-.31-.18-.45-.39-.32-.46-.47-.69l-.93.11a3.48 3.48 0 0 1 .48 1.23.21.21 0 0 1-.38.11c-.08-.1-.39-.84-.57-1.27a10 10 0 0 0 .23 2l.13.08c.03.04 0 .08.04.04zM.96 10.54c-.11.21-.26.22.29.71s1 .88 1.59 1.27v-.08c0-.18-.06-.32-.06-.32-.15.19-.43-.06-.65-.27-.42-.41-.79-.86-1.18-1.3.02 0 .02-.02.01-.01zm2 .5c.34-.28.38.13.55.43 0 0 .08-.22.14-.42a6.59 6.59 0 0 1-1.79-1.67c-.22.25-.44.51-.65.78a19 19 0 0 1 1.43 1.52v-.1c0-.18 0-.52.23-.44a.25.25 0 0 1 .09-.1zm1.81-1.29h.12c.12 0-.01.24-.12 0zm-.92.54a.34.34 0 0 1 .28 0c0-.25.06-.26.08-.37a1.53 1.53 0 0 1 .16-.34h-.08a6.12 6.12 0 0 1-1.44-1.16l-.47.49-.24.24a11.9 11.9 0 0 0 1.61 1.49.3.3 0 0 1 .1-.35zM3.13 8.1a5.47 5.47 0 0 0 1.83 1.23 2.53 2.53 0 0 1 0-.61.28.28 0 0 1 .44-.1 4.26 4.26 0 0 1 .19-.7 6.61 6.61 0 0 1-1.44-.83c-.31.34-.64.67-1 1-.01-.04-.07-.03-.02.03z"
                    fillRule="evenodd"
                  />
                </svg>
                Sdílet
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  user: UserDuck.getUser(state)
});

export default connect(mapStateToProps)(ShowInfoTable);
